<template>
  <md-button>Zurück zum Dashboard</md-button>
</template>

<script>
export default {
  mounted() {
    let code = this.$route.query;
    if (code && code.scope && code.scope.indexOf("activity") >= 0) {
      this.$store
        .dispatch("strava", code)
        .then(() => {
          this.$router.replace("/pages/settings").catch(err => {
            console.log(err);
            throw new Error(`Problem handling something: ${err}.`);
          });
          // Tell user he's registered
          this.$notify({
            timeout: 5000,
            message: "Du bist jetzt mit Strava verbunden!",
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success"
          });
        })
        .catch(err => {
          this.$notify({
            timeout: 5000,
            message: err.message,
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "error"
          });
        });
    } else {
      this.$router.push("/").catch(err => {
        console.log(err);
        throw new Error(`Problem handling something: ${err}.`);
      });
      this.$notify({
        timeout: 5000,
        message:
          "Wir haben leider keine Rechte zu deinen Aktivitäten erhalten, bitte versuche es nochmal.",
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "error"
      });
    }
  }
};
</script>
